import { exec } from "child_process"
import { useEffect, useState } from "react"

const EmbedVideo = ({ url }) => {
    const [ videoUrl, setVideoUrl] = useState<string | null>(null)
    useEffect(() => {
        let urlParts = url.split("/")
        if ((/youtu\.be|youtube.com/).exec(url)) {
            setVideoUrl(`https://youtube.com/embed/${urlParts.pop()}`)
        } else if ((/vimeo\.com/).exec(url)) {
            setVideoUrl(`https://player.vimeo.com/video/${urlParts.pop()}`)
        }
    }, [url])

    return (
        <>
            {setVideoUrl && (
                <iframe src={videoUrl} width={'100%'} />
            )}
        </>
    )
}
export default EmbedVideo